import { GOD } from 'api/admins'
import { useSession } from 'app/components/providers/SessionProvider'
import { isHostDomainClient } from 'app/utils/domainClient'

export function useRightNavData({ user: userProp, hasAdminRole: hasAdminRoleProp } = {}) {
    const { user: sessionUser, hasAdminRole: sessionHasAdminRole } = useSession()
    const isHostDomain = isHostDomainClient()

    // Use prop user if provided, otherwise fall back to session user
    const user = userProp ?? sessionUser ?? null

    // Session hasAdminRole from layout; fallback to GOD so admin link always shows for GOD
    const hasAdminRole = hasAdminRoleProp ?? sessionHasAdminRole ?? user?.role === GOD

    return {
        user,
        isHostDomain,
        hasAdminRole
    }
}
